/** ms */
export const SECOND_MS = 1000
export const MINUTE_MS = SECOND_MS * 60
export const HOUR_MS = MINUTE_MS * 60
export const DAY_MS = HOUR_MS * 24
/** sec */
export const MINUTE_SEC = 60
export const HOUR_SEC = MINUTE_SEC * 60
export const DAY_SEC = HOUR_SEC * 24
export const WEEK_SEC = DAY_SEC * 7
